module.exports = __webpack_public_path__ + "static/media/ic_josm.e81857d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_josm.svg
// module id = 300
// module chunks = 0